module.exports = __webpack_public_path__ + "img/mobile.c6e29a25.png";